//@flow

import Mustache from "mustache";
import template from "./site-message.mustache";

const pageHeader = document.getElementById('page-header');

var displaySiteMessage = function(e) {
    let siteMessage = Mustache.render(template, e.detail);
    pageHeader.insertAdjacentHTML('afterend', siteMessage);
}

var dismissSiteMessage = function(e) {
    if(e.target && e.target.classList.contains('site-message-close')) {
        let siteMessage = document.getElementById('site-message');
        siteMessage.style.display = 'none';
    }
}

export function init() {
    window.addEventListener('site-message__received', displaySiteMessage);
    document.addEventListener('click', dismissSiteMessage);
}